import { render, staticRenderFns } from "./ReportingCategoryAdd.vue?vue&type=template&id=bb3f3ae8"
import script from "./ReportingCategoryAdd.vue?vue&type=script&lang=js"
export * from "./ReportingCategoryAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports